module.exports = __webpack_public_path__ + "static/media/icon-supplies-shaver.ee3f66ee.svg";